import React, { useState } from 'react';

import { MenuIcon, CloseIcon } from '@/components/Icons';
import { useItineraryContext } from '@/context/ItineraryContext';

import {
  StyledArrowTail,
  StyledCloseMenuButton,
  StyledNavHeader,
  StyledNavItem,
  StyledNavItemsWrapper,
  StyledNavTrigger,
  StyledNavWrapper,
  StyledOpenMenuButton,
} from './styles';

import { StyledLogoWrapper } from '../Top/styles';

export type DrawerNavbarVariant = 'primary' | 'secondary';

interface DrawerNavbarProps {
  variant?: DrawerNavbarVariant;
}

export function DrawerNavbar({ variant = 'primary' }: DrawerNavbarProps) {
  const [opened, setOpened] = useState(false);
  const { navigation } = useItineraryContext();

  return (
    <>
      {/* Trigger */}
      <StyledNavTrigger $variant={variant}>
        <StyledLogoWrapper>
          <img src={variant === 'primary' ? '/white_wrapped.png' : '/black_wrapped.png'} alt="logo" />
          {/* <img src={variant === 'primary' ? '/white_standard.png' : '/black_standard.png'} alt="logo" /> */}
        </StyledLogoWrapper>
        <StyledOpenMenuButton
          $variant={variant}
          onClick={() => {
            setOpened(true);
          }}
        >
          <MenuIcon /> Menu
        </StyledOpenMenuButton>
      </StyledNavTrigger>

      {/* Navbar */}
      <StyledNavWrapper $opened={opened}>
        <StyledNavHeader>
          <img src="/white_wrapped.png" alt="logo" />
          <StyledCloseMenuButton
            onClick={() => {
              setOpened(false);
            }}
          >
            <CloseIcon /> Menu
          </StyledCloseMenuButton>
        </StyledNavHeader>
        <StyledNavItemsWrapper>
          {navigation.navigationItems.map((item, index) => (
            <React.Fragment key={item.key}>
              <StyledNavItem
                onClick={() => navigation.to(item.key)}
                $active={navigation.currentPage?.path === item.path}
              >
                {`${index + 1}. ${item.name}`}
                <StyledArrowTail> &gt; </StyledArrowTail>
              </StyledNavItem>
            </React.Fragment>
          ))}
        </StyledNavItemsWrapper>
      </StyledNavWrapper>
    </>
  );
}
